/* eslint-disable max-len */
export default {
    title: 'O nas',
    subtitle: 'Lemlock został stworzony w odpowiedzi na zwiększone zapotrzebowanie na posiadanie sprawdzonych oraz cyberbezpiecznych produktów zarówno pod względem technicznym, jak i prawnym.',
    values: {
        title: 'Wartości'
    },
    mission_vision: {
        mission: {
            title: 'Misja',
            text: 'Zapewnienie, że systemy i rozwiązania naszych klientów są zabezpieczone w odpowiedni sposób, mając na uwadze zarówno aspekty prawne, jak i techniczne.'
        },
        vision: {
            title: 'Wizja',
            text: 'Lemlock chce być brakującym ogniwem między procedurami prawnymi a nadzorem technicznym, tworząc efekt pełnej synergii na korzyść naszych klientów.'
        },
        verified: {
            text: 'Verified by Lemlock'
        }
    },
    perspectives: {
        title: 'Poznaj nas'
    },
    team: {
        title: 'Team',
        subtitle: 'Zespół Lemlock tworzą testerzy bezpieczeństwa, prawnicy oraz inżynierowie oprogramowania.',
        text: [
            'Ich doświadczenie i kompetencje w zakresie cyberbezpieczeństwa potwierdzają liczne projekty, publikacje naukowe i wystąpienia na krajowych oraz międzynarodowych konferencjach, takich jak Secure Polska, Sieci Komputerowe - Polska czy MMM-ACNS Rosja.',
            'O praktycznej znajomości zagadnień bezpieczeństwa świadczy także znalezienie szeregu podatności w powszechnie używanym oprogramowaniu, np: <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1086" target="_blank" rel="noopener noreferrer">CVE-2013-1086</a>, <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1087" target="_blank" rel="noopener noreferrer">CVE-2013-1087</a>, <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2015-2802" target="_blank" rel="noopener noreferrer">CVE-2015-2802</a>. Każdemu działaniu przyświeca idea rozwijania biznesu w sposób odpowiedzialny oraz zwiększania świadomości z istniejących zagrożeń w przestrzeni online i offline.'
        ]
    },
    clutch: {
        title: 'Oni nam zaufali'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/pl/about.js